<template>
<!-- 竖形流程 -->
  <div>
      <a-steps direction="vertical" :current="resultId"  status="error" v-if="isError == 1">
            <a-step  v-for="(item, index) in processList" :key="index">
                <template slot="title">
                    <div v-if="item">
                      <span class="red">{{item.name}}</span>
                      <span style="margin-left: 10px;"  v-if="item.flag == true && item.type != 'end' && item.type != 'start' ">审批结果：<span :style="{color: resultColor[item.result] }">{{resultList[item.result]}}</span></span>
                    </div>
                </template>
                <template slot="description">
                    <div class="red">{{item.auditor}}</div>
                    <div v-if="item.comment">审批建议：{{item.comment}}</div>
                </template>
                <a-icon v-if="item.result == 0 && item.flag == true " type="check-circle" slot="icon"></a-icon>
                <!-- 通过审批 -->
                <a-icon v-if="item.result == 2 " type="check-circle" slot="icon"></a-icon>
                <!-- 驳回 -->
                <a-icon v-if="item.result == 3 || item.result == 4 || item.result == 6 " type="close-circle" slot="icon"></a-icon>
                <!-- 审批中 -->
                <a-icon  v-if="item.result == 1 && item.flag == true " type="clock-circle" slot="icon"></a-icon>
                <a-icon  v-if="item.result == 0 && item.flag == false " type="clock-circle" slot="icon"></a-icon>
            </a-step>
        </a-steps>
        <a-steps direction="vertical" :current="resultId" v-else>
            <a-step  v-for="(item, index) in processList" :key="index">
                <template slot="title">
                    <div v-if="item">
                      <span class="red">{{item.name}}</span>
                      <span style="margin-left: 10px;"  v-if="item.flag == true && item.type != 'end' && item.type != 'start' ">审批结果：<span :style="{color: resultColor[item.result] }">{{resultList[item.result]}}</span></span>
                    </div>
                </template>
                <template slot="description">
                    <div class="red">{{item.auditor}}</div>
                    <div v-if="item.comment">审批建议：{{item.comment}}</div>
                </template>
                <a-icon v-if="item.result == 0 && item.flag == true " type="check-circle" slot="icon"></a-icon>
                <!-- 通过审批 -->
                <a-icon v-if="item.result == 2 " type="check-circle" slot="icon"></a-icon>
                <!-- 驳回 -->
                <a-icon v-if="item.result == 3 || item.result == 4 || item.result == 6 " type="close-circle" slot="icon"></a-icon>
                <!-- 审批中 -->
                <a-icon  v-if="item.result == 1 && item.flag == true " type="clock-circle" slot="icon"></a-icon>
                <a-icon  v-if="item.result == 0 && item.flag == false " type="clock-circle" slot="icon"></a-icon>
                <!-- <a-icon   v-else type="clock-circle" slot="icon"></a-icon> -->
            </a-step>
        </a-steps>
  </div>
</template>

<script>
import { get_process_all, } from '@/api/activiti'
export default {
    
  	data() {
			return {
                resultList: ['','审批中','通过','驳回','撤销','','中止'],
                resultColor: ['','#FF9959', 'green','#FF7272','#FF7272','','#919191'],
                processList: [],
                resultId: 0,
                isError: 0,
            }
        },
        methods: {
          init(data) {
            get_process_all({
                procInstId: data.procInstId,
                name: data.procDefKey,
                userId: this.$store.getters.userId,
            }).then((res) => {
                if(res.code == 200) {
                    this.processList = res.data.tasks
                    this.resultId = -1
                    for(var i = 0; i < this.processList.length; i++) {
                        console.log( this.isError , ' this.isError ====================')
                        if(this.processList[i].result == 3 || this.processList[i].result ==  4 || this.processList[i].result == 6) {
                        this.isError = 1
                        console.log( this.isError , ' this.isError ====================')
                        } 
                        if(this.processList[i].flag) {
                        this.resultId =  this.resultId + 1
                        console.log( this.resultId, ' this.resultId======================')
                        }
                    }
                    this.processList.splice(0,0)
                        } else {
                            this.$message.error(res.msg)
                        }
                    })

            }
          
        }


}
</script>

<style lang="less" scoped>

</style>